var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondaryContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.595 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -12.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.211,18.457H67.5a3.128,3.128,0,0,1,0-6.257,3.266,3.266,0,0,1,3.1,2.929c.2,1.536,1.849,1.223,2.417,1.081a6.348,6.348,0,0,1-4.806,2.247",
    transform: "translate(-42.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.234,44.527a1.159,1.159,0,0,1-1.138.939H58.76A9.787,9.787,0,0,0,56.2,42.2a5.872,5.872,0,0,1,5.261-4.1c2.986,0,5.46,2.815,5.773,6.427",
    transform: "translate(-36.639 -18.534)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.386,61.179H6.678A1.759,1.759,0,0,1,5,59.843c.455-5.2,4.1-9.243,8.532-9.243s8.077,4.038,8.532,9.243a1.71,1.71,0,0,1-1.678,1.337",
    transform: "translate(0 -27.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.194,22.216a4.41,4.41,0,1,1,4.294-4.408,4.352,4.352,0,0,1-4.294,4.408",
    transform: "translate(-10.663 -0.859)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryContact);
export default __webpack_public_path__ + "static/media/secondary_contact.2f1b95d9b64607037b6229018a551681.svg";
export { ForwardRef as ReactComponent };